<template>


  <div class="col-md-12 col-lg-8"
       v-if="cars.length"
  >
    <div class="delivery pb-4 pt-4">

        <h3 class="delivery-table__subtitle mb-0 mb-md-3">
          <slot name="table-city-dynamic-title" v-if="carsForCity.length">
              Стоимость доставки
          </slot>
          <template v-else>
            Стоимость доставки по указанному адресу
          </template>
        </h3>

      <table class="table table-cell-middle">

        <thead>
        <tr class="d-none d-md-table-row">
          <th scope="col">Тип транспорта</th>
          <th scope="col"></th>
          <th scope="col" v-if="carsForCity.length">По городу</th>
          <th scope="col" v-if="carsForCity.length">Межгород</th>

          <th class="nowrap" scope="col" v-if="carsForCityAndAddress.length">Стоимость (с НДС)</th>

        </tr>
        </thead>

        <tbody>

        <template v-for="car in cars">

          <tr class="d-none d-md-table-row">
            <td class="delivery-table__value">
              {{ car.title }}
              <span v-if="car.subTitle">{{ car.subTitle }}</span>
              <span v-if="isOperator && car.skuName">{{ car.skuName }}</span>
            </td>
            <td><i :class="car.iconClass"></i></td>
            <td class="delivery-table__value" v-if="!isHidePrice && car.priceCity">{{ car.priceCity }}</td>
            <td class="delivery-table__value" v-if="!isHidePrice && car.priceInterCity">{{ car.priceInterCity }}</td>
            <td class="delivery-table__value" v-if="!isHidePrice && car.price">{{ car.price }}</td>
            <td class="delivery-table__value" v-if="isHidePrice" v-html="hiddenPriceMessage"></td>
          </tr>

          <tr class="d-table-row d-md-none">
            <td class="d-flex flex-column px-0" colspan="4">

              <i :class="car.iconClass" class="mb-3"></i>

              <span class="delivery-table__value mb-2">{{ car.title }}</span>

              <span class="delivery-table__city" v-if="!isHidePrice && car.priceCity">
                  <span class="delivery-table__label d-md-none">По городу: </span>
                  <span class="delivery-table__value">{{ car.priceCity }}</span>
                </span>

              <span class="delivery-table__country" v-if="!isHidePrice && car.priceInterCity">
                  <span class="delivery-table__label d-md-none">Межгород: </span>
                  <span class="delivery-table__value">{{ car.priceInterCity }}</span>
                </span>

              <span class="delivery-table__city" v-if="!isHidePrice && car.price">
                  <span class="delivery-table__label d-md-none">Стоимость (с НДС): </span>
                  <span class="delivery-table__value">{{ car.price }}</span>
                </span>
              <span class="delivery-table__city" v-if="isHidePrice">
                  <span class="delivery-table__label d-md-none">Стоимость (с НДС): </span>
                  <span class="delivery-table__value" v-html="hiddenPriceMessage"></span>
                </span>
            </td>
          </tr>

        </template>

        </tbody>
      </table>
    </div>
  </div>

</template>

<script>

import {isNumeric} from '../../libs/util';

/** Сравнивает по цене */
const cmpByPrice = (a, b) => {
  a = a.sortPrice;
  b = b.sortPrice;
  return a > b ? 1 : b > a ? -1 : 0;
};

export default {
  name: "DeliveryCars",

  props: [ 'carsForCity', 'carsForCityAndAddress', 'isOperator', 'isHidePrice', 'hiddenPriceMessage'],

  computed: {
    cars() {
      let cars = [];
      /** Приводятся к виду
       * {
       *  title: Газель · 1,5 т / 4 м
       *  subTitle:
       *  iconClass: icn-small-truck delivery-table__icon--big
       *  priceCity: от 2 500 ₽
       *  priceInterCity: от 2 500 ₽
       *  price: от 2 500 ₽
       * }
       * */
      if (this.carsForCity.length) {
        for (let car of this.carsForCity) {
          cars.push({
            title: this.getCarTitle(car),
            subTitle: '',
            isManipulator: car.is_manipulator,
            skuName: car.sku_name,
            iconClass: car.css,
            priceCity: this.price(car.price_inreg),
            priceInterCity: this.price(car.price_diffreg),
            sortPrice: parseFloat(car.price_inreg ? car.price_inreg : car.price_diffreg)
          });
        }
      } else if (this.carsForCityAndAddress.length) {
        for (let car of this.carsForCityAndAddress) {
          cars.push({
            title: this.getCarTitle(car),
            subTitle: '',
            isManipulator: car.is_manipulator,
            skuName: car.sku_name,
            iconClass: car.css,
            price: this.price(car.price),
            sortPrice: parseFloat(car.price)
          });
        }
      }
      cars = cars.filter(car => car.sortPrice < 999999); // Убрать с ценой > 999 999
      cars.sort(cmpByPrice); // Отсортировать по цене
      return cars;
    }
  },

  methods: {
    price(p, prefix = '') {
      return isNumeric(p) ? `${prefix}${parseInt(p).toLocaleString()} ₽` : '-';
    },

    getCarTitle(car) {
      const middleText = `· ${car.weight} т / ${car.length} м`

      return car.is_manipulator ?
          `Манипулятор ${middleText} (включена разгрузка)` :
          `${car.type} ${middleText}`
    }
  },

};
</script>

<style scoped>
.delivery .delivery-table-title {
  display: inline-block;
  margin-top: 24px;
  font-weight: 500;
}

.delivery-table__subtitle {
  font-size: 1rem;
}

.delivery-table__title, .delivery-table__city, .delivery-table__country, .delivery-table__value, .delivery-table__item,
.delivery-table__subtitle {
  font-weight: 500 !important;
}


.delivery .icn-small-truck {
  font-size: 24px;
}

.delivery .icn-medium-truck {
  font-size: 28px;
}

.delivery .icn-big-truck,
.delivery .icn-big-medium-truck {
  font-size: 30px;
}

.delivery .icn-crane-truck {
  font-size: 30px;
}

.table-cell-middle td {
  vertical-align: middle;
}
.nowrap {
  white-space: nowrap;
}
@media (max-width: 767px){
  .delivery-table__label{
    margin-right: 8px;
    font-weight: 400;
  }
}
</style>